module.exports = __webpack_public_path__ + "img/icon-login.182412c4.svg";